<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.saleorder') }}
            <template v-if="ready">
              >
              {{ sale.so_code }}
            </template>
          </div>
        </div>
        <div class="col-md-8 right">
          <div
            v-if="ready"
            class="action">
            <div
              v-if="showOptionButton"
              class="dropdown item">
              <button
                id="dropdownMenuButton"
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton">
                <a
                  v-if="hasRoleDelete"
                  class="dropdown-item"
                  @click="openConfirmdeleteModal()">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
            <div
              class="dropdown nodro item">
              <button
                class="btn no-bg text-secondary"
                type="button"
                @click="openCloneModal()">
                <i class="fas fa-copy"/>
                <span class="name">{{ $t('button.clone') }}</span>
              </button>
            </div>
            <div
              class="dropdown item">
              <button
                id="dropdownMenuButton"
                class="btn no-bg dropdown-toggle text-secondary"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-download"/>
                <span class="name">{{ $t('button.download') }}</span>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton">
                <a
                  class="dropdown-item"
                  @click="downloadPdf()">
                  <span class="text-secondary">{{ $t('message.filename', {string: 'PDF'}) }}</span>
                </a>
              </div>
            </div>
            <!-- <div class="dropdown nodro item">
              <button class="btn no-bg text-secondary" type="button">
                <i class="fas fa-envelope"></i>
                <span class="name">{{ $t('button.sendemail') }}</span>
              </button>
            </div> -->
            <!-- <div class="dropdown nodro item">
              <button class="btn no-bg text-secondary" type="button" @click="openShareLinkModal()">
                <i class="fas fa-link"></i>
                <span class="name">{{ $t('button.sharelink') }}</span>
              </button>
            </div> -->
            <div
              class="dropdown nodro item">
              <button
                class="btn no-bg text-secondary"
                type="button"
                @click="openPrintModal()">
                <i class="fas fa-print"/>
                <span class="name">{{ $t('button.print') }}</span>
              </button>
            </div>
            <!-- status button -->
            <div
              v-if="sale.status == 'padding' && hasRoleApprove"
              class="dropdown item">
              <template>
                <button
                  v-if="sale.status == 'padding'"
                  class="btn no-bg dropdown-toggle text-warning"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-circle"/>
                  <span class="name">{{ $t('status.so.padding') }}</span>
                </button>
                <button
                  v-if="sale.status == 'approved'"
                  class="btn no-bg dropdown-toggle text-info"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-check-circle"/>
                  <span class="name">{{ $t('status.so.approved') }}</span>
                </button>
                <button
                  v-if="sale.status == 'rejected'"
                  class="btn no-bg dropdown-toggle text-danger"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-times-circle"/>
                  <span class="name">{{ $t('status.so.rejected') }}</span>
                </button>
              </template>
              <div class="dropdown-menu dropdown-menu-right">
                <a
                  v-if="sale.status == 'padding'"
                  class="dropdown-item"
                  @click="updateSaleStatus({so_id: sale.so_id, status: 'approved'})">
                  <i
                    class="far fa-check-circle text-info"
                    style="position: relative; left: -7px;"/>
                  <span class="text-info">{{ $t('status.so.approve') }}</span>
                </a>
                <a
                  v-if="sale.status == 'padding'"
                  class="dropdown-item"
                  @click="updateSaleStatus({so_id: sale.so_id, status: 'rejected'})">
                  <i
                    class="far fa-times-circle text-danger"
                    style="position: relative; left: -7px;"/>
                  <span class="text-danger">{{ $t('status.so.reject') }}</span>
                </a>
              </div>
            </div>
            <!-- status message -->
            <div
              v-else
              class="dropdown nodro item">
              <template>
                <span
                  v-if="getSaleStatus(sale, $t, mixin).status == 'padding'"
                  class="text-warning">
                  {{ getSaleStatus(sale, $t, mixin).message }}
                </span>
                <span
                  v-else-if="getSaleStatus(sale, $t, mixin).status == 'completed'"
                  class="text-success">
                  {{ getSaleStatus(sale, $t, mixin).message }}
                </span>
                <span
                  v-else-if="getSaleStatus(sale, $t, mixin).status == 'uncompleted'"
                  class="text-info">
                  {{ getSaleStatus(sale, $t, mixin).message }}
                </span>
                <span
                  v-else
                  class="text-danger">
                  {{ getSaleStatus(sale, $t, mixin).message }}
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <WrapperDoc>
          <template #form>
            <section>
              <div class="col-md-12 no-padding">
                <section-header
                  :title="$t('message.customer')"
                  :subtitle="$t('series.so') + ' ' + sale.so_code"/>
                <div class="form-row">
                  <div class="col-md-12">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.storecompanyperson') }}</label>
                        <selectize
                          v-model="form.pickedCustomerId"
                          :default="form.defaultCustomerId"
                          :updateoption="form.updateOptionCustomer"
                          :options="form.optionCustomers"
                          :multiple="false"
                          :create="true"
                          :loading="form.loadingCustomer"
                          :validation="form.trickValidationCustomer"
                          :placeholder="$t('placeholder.selectorcreate')"
                          :disabled="disabledForm"
                          @add="onAddedCustomer" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="form.pickedCustomerId"
                  class="form-row">
                  <div class="col-md-6">
                    <div
                      class="form-group row"
                      style="height: 100%;">
                      <div class="col-md-12">
                        <label>{{ $t('message.address') }}</label>
                        <textarea
                          v-model="form.customer.address"
                          :disabled="disabledForm"
                          class="form-control"
                          style="height: calc(100% - 37px);"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.tel') }}</label>
                        <input
                          v-model="form.customer.tel"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control"
                        >
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.email') }}</label>
                        <input
                          v-model="form.customer.email"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control"
                        >
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.taxpayerno') }}</label>
                        <input
                          v-model="form.customer.tax_id"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <div class="col-md-12 no-padding">
                <section-header :title="$t('message.date')"/>
                <div class="form-row">
                  <div class="col">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.date') }}</label>
                        <BaseInputDatePicker
                          v-model="form.created_at"
                          :disabled="disabledForm"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('apps.sales.message.saletype') }}</label>
                        <BaseDropdown
                          v-model="form.sale_type"
                          :options="saleOptions"
                          :disabled="disabledForm"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="col"
                    @click="isFocusOnInputScheduled = false">
                    <div class="form-group row">
                      <div class="col">
                        <label>{{ $t('message.credittype') }}</label>
                        <select
                          v-if="form.selectedCredit !== 'custom'"
                          v-model="form.selectedCredit"
                          :disabled="disabledForm"
                          class="form-control custom-select"
                        >
                          <option value="cash">{{ $t('message.cash') }}</option>
                          <option value="days.15">{{ $t('message.creditdasys', {number: 15}) }}</option>
                          <option value="days.30">{{ $t('message.creditdasys', {number: 30}) }}</option>
                          <option value="days.60">{{ $t('message.creditdasys', {number: 60}) }}</option>
                          <option value="days.90">{{ $t('message.creditdasys', {number: 90}) }}</option>
                          <option value="custom">{{ $t('message.customcreditdays') }}</option>
                        </select>
                        <div
                          v-else
                          class="input-group">
                          <input
                            ref="custom_credit_days"
                            v-model="form.inputCustomCreditDay"
                            :disabled="disabledForm"
                            type="text"
                            class="form-control text-right number-only text-select-all"
                            style="border-right: none;"
                            @keyup="keyupInputCustomCreditDay">
                          <div class="input-group-prepend">
                            <button
                              :disabled="disabledForm"
                              :class="[
                                disabledForm ? 'btn-light' : 'btn-web'
                              ]"
                              class="btn"
                              type="button"
                              style="border: 1px solid #ced4da;"
                              @click="form.selectedCredit = 'cash'">
                              {{ $t('message.creditdasysbutton') }} <i
                                v-if="!disabledForm"
                                class="far fa-times-circle"/>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="form.selectedCredit !== 'cash'"
                    :class="{'disabled': false}"
                    class="col scheduled">
                    <div class="form-group row">
                      <div
                        class="col-md-12"
                        style="position: relative;">
                        <div class="overlay"/>
                        <label>{{ $t('message.scheduled_at') }}</label>
                        <BaseInputDatePicker
                          v-model="form.scheduled_at"
                          :availableDates="{ start: form.created_at, end: null }"
                          :disabled="disabledForm"
                          @dayclick="isFocusOnInputScheduled = true"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <div class="col-md-12 no-padding">
                <section-header :title="$t('message.orderlist')"/>
                <order
                  :validation="form.trickValidation"
                  :data="form.orders"
                  :createAble="true"
                  :showProductImage="true"
                  :disabled="disabledForm"
                  :showTooltipTaxHint="showTooltipTaxHint"
                  type="so"
                  @submit="onSubmitOrder"
                />
              </div>
            </section>
            <section class="no-margin">
              <div class="col-md-12 no-padding">
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <b-form-textarea
                          :placeholder="$t('placeholder.note')"
                          v-model="form.note"
                          :disabled="disabledForm"
                          style="min-height: 126px;" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 pl-2">
                    <div class="col-md-12 row no-padding no-margin">
                      <div class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding mb-2">
                          {{ $t('message.total') }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(total.sub) }}
                        </div>
                      </div>
                      <div
                        v-if="total.discount > 0"
                        class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding mb-2">
                          {{ $t('message.discount') }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(total.discount) }}
                        </div>
                      </div>
                      <div
                        v-if="total.discount > 0"
                        class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding mb-2">
                          {{ $t('message.discounted_total') }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(total.sub - total.discount) }}
                        </div>
                      </div>
                      <div
                        v-if="total.taxes.vat.inclusive > 0"
                        class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding mb-2">
                          {{ $t('message.totalexcludingvat') }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(total.untaxed) }}
                        </div>
                      </div>
                      <div
                        v-for="(tax, index) in taxResults"
                        :key="index"
                        class="col-12 row no-margin no-padding"
                      >
                        <div class="col-6 no-padding mb-2">
                          {{ tax.displayText }}
                        </div>
                        <div class="col-6 no-padding mb-2 text-right">
                          {{ getNumber(tax.total) }}
                        </div>
                      </div>
                      <div class="col-12 row no-margin no-padding">
                        <div class="col-6 no-padding">
                          {{ $t('message.grandtotal') }}
                        </div>
                        <div class="col-6 no-padding text-right">
                          <span :class="[{'text-underline-border': !form.switchWithHoldingTax}]">
                            {{ getNumber(total.grand) }}
                          </span>
                        </div>
                      </div>
                      <div
                        v-if="showLegacyWht()"
                        class="col-12 row no-margin no-padding">
                        <div class="col-12 no-padding"><hr style="border-top: solid 1px #D8E2E7;"></div>
                      </div>
                    </div>
                    <template v-if="showLegacyWht()">
                      <div
                        class="form-group row mb-0"
                        style="height: 35px;">
                        <div
                          class="col-8"
                          style="position: relative; top: 3px;opacity: 0.3;"
                          @click="showTooltipTaxHint = true"
                        >
                          <vs-switch
                            v-model="form.switchWithHoldingTax"
                            :disabled="true"
                            style="float: left;margin: 0 10px 0 0"
                            color="#A3CA76"
                          />
                          {{ $t('message.wht') }}
                        </div>
                        <div class="col-4">
                          <select
                            v-if="form.switchWithHoldingTax"
                            v-model="form.inputWithHoldingTax"
                            :disabled="disabledForm"
                            class="custom-select form-control">
                            <option value="0">0%</option>
                            <option value="-1">{{ $t('message.wht1') }}</option>
                            <option value="-2">{{ $t('message.wht2') }}</option>
                            <option value="-3">{{ $t('message.wht3') }}</option>
                            <option value="-5">{{ $t('message.wht5') }}</option>
                          </select>
                        </div>
                      </div>
                      <div
                        v-if="form.switchWithHoldingTax"
                        class="col-md-12 row no-padding mt-2 ml-0 mr-0">
                        <div class="col-12 row no-margin no-padding">
                          <div class="col-6 no-padding mb-2">
                            {{ $t('message.wht') }}
                          </div>
                          <div class="col-6 no-padding mb-2 text-right">
                            {{ getNumber(total.taxes.wht.toString().replace("-", "")) }}
                          </div>
                        </div>
                        <div class="col-12 row no-margin no-padding">
                          <div class="col-6 no-padding">
                            {{ $t('message.paymentamount') }}
                          </div>
                          <div class="col-6 no-padding text-right">
                            <span class="text-underline-border">{{ getNumber(total.payment) }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </section>
            <section
              v-if="!disabledForm"
              class="action-bar"
            >
              <template>
                <div
                  v-if="!$store.state.app.loading"
                  class="col-md-12 text-right">
                  <button
                    class="btn btn-web"
                    @click="form.trickValidation++;">{{ $t('button.save') }}</button>
                </div>
                <div
                  v-else
                  class="col-md-12 text-right">
                  <!-- <button class="btn btn-light btn-block-mobile-only" disabled>{{ $t('button.cancel') }}</button> -->
                  <button
                    class="btn btn-web btn-block-mobile-only"
                    disabled><i class="fas fa-spinner spin"/></button>
                </div>
              </template>
            </section>
          </template>
          <template #ref>
            <DocRef
              :refDoc="`so`"
              :refId="sale.so_id"
              :refCode="sale.so_code"
              :showLog="getSaleSetting.log_topic.is_active"
              :showAttachFile="getSaleSetting.attach_file.is_active"
              :logTopics="getSaleSetting.log_topic.options"
              :isSubmitted="isSubmitted"
            >
              <RefSO
                :sale="sale"
                :disabled="!hasRoleCreate"
              />
            </DocRef>
          </template>
        </WrapperDoc>
      </template>
    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog"
        role="document">
        <div
          v-if="ready"
          class="modal-content">
          <div
            :class="[{'no-border-bottom': sale.reference.invoices.length == 0 && sale.reference.goodsissues.length == 0}]"
            class="modal-header">
            <h5 class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="sale.reference.invoices.length > 0 || sale.reference.goodsissues.length > 0"
            class="modal-body">
            <p class="text-danger">
              <strong>{{ $t('message.refdocswillbedeleted') }}</strong>
            </p>
            <div v-if="sale.reference.invoices.length > 0">
              <p class="m-0">
                <strong>{{ $t('documents.in') }} ({{ sale.reference.invoices.length }})</strong>
              </p>
              <ul>
                <li
                  v-for="(invoice, index) in sale.reference.invoices"
                  :key="index">
                  <router-link-custom
                    :to="{name: 'AccountsInvoiceEdit', query: {
                      in_id: invoice.in_id,
                      in_code: invoice.in_code
                    }}"
                    :text="invoice.in_code"
                    :status="{
                      text: getInvoiceStatus(invoice, $t, mixin).message,
                      color: getColorFormStatus(getInvoiceStatus(invoice, $t, mixin).status),
                      type: 'icon'
                    }"
                    :to_appid="12"
                    :current_appid="5"/>
                </li>
              </ul>
            </div>
            <div v-if="sale.reference.invoices.length > 0">
              <p class="m-0">
                <strong>{{ $t('documents.pe') }} ({{ paymentsCount }})</strong>
              </p>
              <ul>
                <li
                  v-for="(invoice, index) in sale.reference.invoices"
                  :key="index">
                  <div
                    v-for="(payment, index) in invoice.reference.payments"
                    :key="`payment-${index}`">
                    <router-link-custom
                      :to="{name: 'AccountsPaymentEntryEdit', query: {
                        pe_id: payment.pe_id,
                        pe_code: payment.pe_code
                      }}"
                      :text="payment.pe_code"
                      :status="{
                        text: getPaymentStatus(payment, $t).message,
                        color: getColorFormStatus(getPaymentStatus(payment, $t).status),
                        type: 'icon'
                      }"
                      :to_appid="12"
                      :current_appid="4"/>
                  </div>
                </li>
              </ul>
            </div>
            <div v-if="sale.reference.goodsissues.length > 0">
              <p class="m-0">
                <strong>{{ $t('documents.gi') }} ({{ sale.reference.goodsissues.length }})</strong>
              </p>
              <ul>
                <li
                  v-for="(goodsissue, index) in sale.reference.goodsissues"
                  :key="index">
                  <router-link-custom
                    :to="{name: 'GoodsIssueEdit', query: {
                      gi_id: goodsissue.gi_id,
                      gi_code: goodsissue.gi_code
                    }}"
                    :text="goodsissue.gi_code"
                    :status="{
                      text: getGoodsIssueStatus(goodsissue, $t).message,
                      color: getColorFormStatus(getGoodsIssueStatus(goodsissue, $t).status),
                      type: 'icon'
                    }"
                    :to_appid="3"
                    :current_appid="5"/>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="printModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg-90-percent"
        role="document">
        <div class="modal-content">
          <div
            class="modal-body p-0"
            style="background: #C9CCCE;height: 660px;overflow: auto;">
            <printsale-view
              v-if="ready"
              :sale="sale"
              :fontSize="getSaleSetting.doc_template.font_size"
              :isFixedSignatureBottom="getSaleSetting.doc_template.is_fixed_signature_bottom"
              class="print-template"/>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-web"
              @click="onclickPrint()">{{ $t('button.print') }}</button>
            <button
              type="button"
              class="btn btn-light"
              @click="closePrintModal()">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="sharelinkModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t('button.sharelink') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeShareLinkModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section class="link">
              <section-title :title="$t('message.link')"/>
              <div class="col-md-12 p-0 wrapper-link">
                <input
                  id="sharelink"
                  type="text"
                  class="form-control text-clipboard"
                  readonly="readonly"
                  value="https://doc.treesoft.io/th/eWRhpRV">
                <a
                  href="https://doc.treesoft.io/th/eWRhpRV"
                  target="_blank"
                  class="btn btn-sm btn-secondary"
                  style="right: 59px;">ไปยัง</a>
                <button
                  class="btn btn-sm btn-secondary btn-copy"
                  data-ref="sharelink"
                  style="right: 7px;">คัดลอก</button>
              </div>
            </section>
            <section class="mb-0">
              <section-title :title="$t('message.permissions')"/>
              <div class="col-md-12 p-0">
                <div class="form-row">
                  <div class="col-6">
                    <div class="form-group row mb-2">
                      <div class="col-12">
                        <vs-checkbox
                          color="#A3CA76"
                          style="float: left;margin: 0;"
                        >{{ $t('button.download') }}</vs-checkbox>
                      </div>
                    </div>
                    <div class="form-group row mb-0">
                      <div class="col-12">
                        <vs-checkbox
                          color="#A3CA76"
                          style="float: left;margin: 0;"
                        >{{ $t('message.approve') }}</vs-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group row mb-2">
                      <div class="col-12">
                        <vs-checkbox
                          color="#A3CA76"
                          style="float: left;margin: 0;"
                        >{{ $t('button.print') }}</vs-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeShareLinkModal()">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

    <BaseConfirmCloneModal
      :show="modalConfirmClone.show"
      :loading="modalConfirmClone.loading"
      @onClose="handleCloseCloneModal"
      @onCancel="handleCancleCloneModal"
      @onConfirm="handleConfirmCloneModal({
        payload: payloadClone,
        createApiFn: insertSale,
        redirectTo: 'SaleOrderAll',
        refCode: 'sale.so_code',
      })"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import printsaleView from '@/components/apps/sales/so/include/PrintSale.vue'
import WrapperDoc from '@/components/combine/WrapperDoc.vue'
import DocRef from '@/components/combine/DocRef.vue'
import RefSO from '@/components/apps/sales/so/include/RefSO.vue'
import BaseConfirmCloneModal from '@/components/base/BaseConfirmCloneModal'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import confirmCloneMixin from '@/mixins/confirmClone'
import { getMasterDataText } from '../../../../helpers'
const jwt = require('jsonwebtoken')

export default {
  name: 'SaleOrderEdit',
  components: {
    printsaleView,
    WrapperDoc,
    DocRef,
    RefSO,
    BaseConfirmCloneModal,
  },
  mixins: [discardFormMixin, userPermissionMixin, confirmCloneMixin],
  data () {
    return {
      ready: false,

      form: {
        pickedCustomerId: null,
        defaultCustomerId: null,
        optionCustomers: [],
        updateOptionCustomer: null,
        loadingCustomer: false,
        trickValidationCustomer: 0,
        customer: {
          address: null,
          tax_id: null,
          email: null,
          tel: null,
        },

        created_at: new Date(),

        sale_type: null,

        scheduled_at: new Date(),
        selectedCredit: '',

        inputCustomCreditDay: 0,
        inputWithHoldingTax: 0,

        switchWithHoldingTax: false,

        note: '',
        trickValidation: 0,
        orders: [],
      },

      originalForm: null,

      isFocusOnInputScheduled: false,

      isCreateAnother: false,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      isSubmitted: false,

      showTooltipTaxHint: false,
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      products: 'getProducts',
      customers: 'getCustomers',
      currency: 'getCurrency',
      sale: 'getSale',
      dateformat: 'getDateFormat',
      getSaleStatus: 'getSaleStatus',
      vat: 'getVat',
      getCustomerById: 'getCustomerById',
      getPartnerContact: 'getPartnerContact',
      getDataSetPartnerUpdate: 'getDataSetPartnerUpdate',
      getShopInfo: 'getShopInfo',
      getLang: 'getLang',
      getInvoiceStatus: 'getInvoiceStatus',
      getGoodsIssueStatus: 'getGoodsIssueStatus',
      getPaymentStatus: 'getPaymentStatus',
      getSaleSetting: 'getSaleSetting',
      saleSetting: 'getSaleSetting',
    }),
    saleTypes() {
      if (this.saleSetting && this.saleSetting.types) {
        return this.saleSetting.types
      }
      return []
    },
    saleOptions() {
      return this.saleTypes
        .filter((type) => type.is_active)
        .map((type) => {
          return {
            text: getMasterDataText(type.name, this.$t),
            value: type.name,
          }
        })
    },
    defaultSaleType() {
      return this.saleTypes.find((type) => type.is_default).name
    },
    total () {
      let orders = this.getDataSetOrders(this.form.orders)
      return this.getTotal(orders)
    },
    taxResults () {
      const isGroupTaxName = false
      const oders = this.getDataSetOrders(this.form.orders)
      return this.getTaxesByOrders(oders, isGroupTaxName).map((tax) => {
        return {
          form_type: tax.form_type,
          taxRate: tax.amount,
          total: (() => {
            if (tax.amount <= -1) {
              return Math.abs(tax.total)
            }
            return tax.total
          })(),
          displayText: tax.displayText,
        }
      })
    },
    whtRate () {
      var whtPercent = undefined
      for (let i in this.sale.orders) {
        let order = this.sale.orders[i]
        for (let j in order.taxes) {
          let tax = order.taxes[j]
          if (tax.name == '{wht}') {
            whtPercent = tax.amount
          }
        }
      }
      return whtPercent
    },
    paymentsCount () {
      var count = 0

      if (!this.sale) return 0

      this.sale.reference.invoices.map(invoice => {
        invoice.reference.payments.map(payment => {
          count++
        })
      })

      return count
    },
    disabledForm () {
      return [
        'approved',
        'rejected',
      ].includes(this.sale.status) || !this.hasRoleEdit
    },
    payloadClone() {
      const dataSet = {
        'status': 'padding',
        'note': this.sale.note,
        'created_at': this.sale.created_at,
        'scheduled_at': this.sale.scheduled_at,
        'customer_id': this.sale.customer.customer_id,
        'sale_type': this.sale.sale_type,
        'credit': {
        	'type': this.sale.credit.type,
        	'days': this.sale.credit.days,
        },
        'orders': this.sale.orders.map((order) => ({
          'item': order.item,
        	'description': order.description,
        	'price': order.price,
          'cost': order.cost,
        	'quantity': order.quantity,
        	'sku_id': order.sku_id,
          'discounts': order.discounts,
          'taxes': order.taxes,
        })),
      }
      return dataSet
    },
  },
  methods: {
    ...mapActions([
      'insertSale',
    ]),
    async onAddedCustomer (value) {
      // show loading selectize
      this.form.loadingCustomer = true

      // insert new customer
      let res = await this.$store.dispatch('insertCustomer', { name: value })

      if (res.success) {
        let customer = res.data
        // update option value
        this.form.updateOptionCustomer = {
          text: value,
          value: customer.customer_id,
          picked: true,
        }
        this.form.optionCustomers.push({
          text: value,
          value: customer.customer_id,
        })
        // finish loading
        this.showFinish(this.$Progress)
        // hide loading selectize
        this.form.loadingCustomer = false
      }
    },
    onSubmitOrder (isValid, orders) {
      this.isSubmitted = true
      this.form.trickValidationCustomer++

      let isInValid = !isValid || (this.form.pickedCustomerId == null || this.form.pickedCustomerId == '')

      if (isInValid) {
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      this.save(this.getDataSetOrders(orders))
    },
    async save (orders) {
      let creditType = 'cash'
      let creditDays = 0

      if (this.form.selectedCredit == 'custom') {
        creditType = 'days'
        creditDays = this.form.inputCustomCreditDay
      } else if (this.form.selectedCredit.search('days.') >= 0) {
        let arr = this.form.selectedCredit.split('.')
        let days = arr[1]
        creditType = 'days'
        creditDays = days
      }

      let dataSet = {
        'so_id': this.sale.so_id,
        'status': this.sale.status,
        'note': this.form.note ? this.form.note : null,
        'created_at': this.form.created_at.toISOString(),
        'scheduled_at': this.form.scheduled_at.toISOString(),
        'customer_id': this.form.pickedCustomerId,
        'sale_type': this.form.sale_type,
        'credit': {
        	'type': creditType,
        	'days': parseInt(creditDays),
        },
        'orders': [],
      }

      for (let i in orders) {
        let order = orders[i]
        dataSet['orders'].push({
          'item': order.item,
        	'description': order.description,
        	'price': order.price,
          'cost': order.cost,
        	'quantity': order.quantity,
        	'sku_id': order.sku_id,
          'discounts': order.discounts,
          'taxes': order.taxes,
        })
      }

      // update customer
      let dataSetCustomerUpdate = this.getDataSetPartnerUpdate('customer', this.form.pickedCustomerId, this.form.customer, this.customers)
      if (dataSetCustomerUpdate !== null) {
        await this.$store.dispatch('updateCustomer', dataSetCustomerUpdate)
        await this.$store.dispatch('getCustomers')
      }

      let res = await this.$store.dispatch('updateSale', dataSet)

      if (res.success) {
        let so_code = res.data.sale.so_code
        // get
        await this.$store.dispatch('getSale', {
          so_id: this.sale.so_id,
        })
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.sale.so_code }),
          color: 'success',
          icon: 'cloud',
        })
        // set data
        this.setData()
        this.isSubmitted = false
        // loading finish
        this.showFinish(this.$Progress)
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }
    },
    getDataSetOrders (orders) {
      const data = _.cloneDeep(orders)
      const newData = []
      // remove key, data we don't need
      for (const i in data) {
        const item = data[i]
        if (item.sku_id) {
          newData.push({
            item: item.item,
            description: item.description,
            sku_id: item.sku_id,
            quantity: parseFloat(item.quantity) || 0,
            price: parseFloat(item.price) || 0,
            cost: item.cost != null ? parseFloat(item.cost) : null,
            discounts: item.discounts.map((discount) => ({
              ...discount,
              type: 'general',
              value_amount: parseFloat(discount.value_amount),
            })),
            taxes: item.taxes.map((tax) => ({
              name: tax.tax_name,
              type: tax.type,
              amount: tax.amount,
              form_type: tax.form_type,
              group_name: tax.group_name,
              is_display_fee_result: tax.is_display_fee_result,
              is_for_sale: tax.is_for_sale,
              is_for_purchase: tax.is_for_purchase,
              fee: tax.fee ? tax.fee : null,
              tax_id: tax.tax_id,
            })),
          })
        }
      }
      return newData
    },
    async clearForm () {
      let that = this

      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      setTimeout(() => {
        that.ready = true
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }, 100)
    },
    keyupInputCustomCreditDay (e) {
      var value = this.form.inputCustomCreditDay.toString()
      if (value) {
        if (value.search('0') == 0) {
          value = value.substring(1, value.length)
          this.form.inputCustomCreditDay = value
        }
      }
    },
    openConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
    async del () {
      let data = {
        so_id: this.sale.so_id,
      }

      // delete reference invoices
      this.sale.reference.invoices.map(async (invoice) => {
        let data = {
          in_id: invoice.in_id,
        }
        let res = await this.$store.dispatch('deleteInvoice', data)
      })

      // delete reference goodsissues
      this.sale.reference.goodsissues.map(async (goodsissue) => {
        let data = {
          gi_id: goodsissue.gi_id,
        }
        let res = await this.$store.dispatch('deleteGoodsissue', data)
      })

      // delete payment
      this.sale.reference.invoices.map(invoice => {
        invoice.reference.payments.map(async (payment) => {
          let data = {
            'pe_id': payment.pe_id,
            'reference': {
              'in_id': invoice.in_id,
            },
          }
          let res = await this.$store.dispatch('deletePayment', data)
        })
      })

      // delete sale
      let res = await this.$store.dispatch('deleteSale', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.sale.so_code }),
          color: 'danger',
          icon: 'delete',
        })
        // finish loading
        this.showFinish(this.$Progress)
        // close modal
        this.closeConfirmdeleteModal()
        // go to
        return this.$router.push({ name: 'SaleOrderAll' })
      }
    },
    async updateSaleStatus (data) {
      this.isSubmitted = true
      let res = await this.$store.dispatch('updateSaleStatus', { so_id: data.so_id, status: data.status })
      this.showFinish(this.$Progress)
      this.isSubmitted = false
    },
    setData () {
      let sale = this.sale
      let form = this.form

      this.form.sale_type = sale.sale_type

      if (sale.credit.type == 'days') {
        var arr = [15, 30, 60, 90]
        if (arr.indexOf(sale.credit.days) >= 0) {
          form.selectedCredit = 'days.' + sale.credit.days.toString()
        } else {
          form.selectedCredit = 'custom'
          form.inputCustomCreditDay = sale.credit.days.toString()
        }
      } else {
        form.selectedCredit = sale.credit.type
      }

      form.switchWithHoldingTax = !!this.whtRate
      form.inputWithHoldingTax = this.whtRate || 0

      form.note = sale.note

      // set customer
      this.form.customer.address = sale.customer.address
      this.form.customer.tax_id = sale.customer.tax_id
      this.form.customer.email = this.getPartnerContact(sale.customer.contacts).email
      this.form.customer.tel = this.getPartnerContact(sale.customer.contacts).tel

      // set defaultCustomerId
      if (this.sale.customer) {
        this.form.defaultCustomerId = this.sale.customer.customer_id
      } else {
        this.form.defaultCustomerId = null
      }

      this.form.created_at = new Date(sale.created_at)
      if (this.form.scheduled_at) {
        this.form.scheduled_at = new Date(sale.scheduled_at)
      }

      // set default data for Order.vue
      this.form.orders = this.getDefaultDataForOrderVue(this.sale.orders)

      // set originalForm
      this.originalForm = _.cloneDeep(form)
    },
    onclickPrint () {
      $('.print-template').printThis({
        importStyle: true, // import style tag
      })
    },
    openPrintModal () {
      $('#printModal').modal('show')

      // set modal height
      $('#printModal .modal-body').css({
        height: window.innerHeight - 125 + 'px',
      })

      $('#printModal .modal-body').animate({ scrollTop: 0 }, 0)
    },
    closePrintModal () {
      $('#printModal').modal('hide')
    },
    openShareLinkModal () {
      $('#sharelinkModal').modal('show')
      $('input#sharelink').select()
    },
    closeShareLinkModal () {
      $('#sharelinkModal').modal('hide')
    },
    async downloadPdf () {
      let data = {
        'type': 'so',
        'lang': this.getLang,
        'id': this.sale.so_id,
        'shop_id': this.getShopInfo.shop_id,
      }

      let token = jwt.sign(data, this.project.config.token.secret, { expiresIn: this.project.config.token.download_pdf_expiresin })

      var link = document.createElement('a')
      // link.href = this.project.config.web.api_doc_gen_01 + 'file/pdf/' + token + '/' + this.sale.so_code
      // link.href = this.project.config.web.doc + 'pdf/' + token + '/' + this.sale.so_code
      link.href = this.project.config.web.api + 'file/pdf/' + token + '/' + this.sale.so_code
      link.target = '_blank'
      link.dispatchEvent(new MouseEvent('click'))
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    customers: function (after, before) {
      this.form.optionCustomers = []
      for (let i in after) {
        let customer = after[i]
        this.form.optionCustomers.push({
          text: customer.customer_name,
          value: customer.customer_id,
        })
      }
    },
    'form.switchWithHoldingTax': {
      handler: function (after) {
        let bool = after
        if (bool == false) {
          this.form.inputWithHoldingTax = '0'
        }
      },
      deep: true,
    },
    'form.selectedCredit': {
      handler: function (after, before) {
        if (!before) {
          return
        }
        let value = after
        if (value.search('days.') >= 0) {
          let arr = value.split('.')
          let days = parseInt(arr[1])
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        } else if (value == 'custom') {
          let that = this
          if (!this.isFocusOnInputScheduled) {
            if (before.search('days.') >= 0) {
              let arr = before.split('.')
              let days = parseInt(arr[1])
              this.form.inputCustomCreditDay = days
            } else {
              this.form.scheduled_at = this.moment(this.form.created_at).toDate()
              this.form.inputCustomCreditDay = 0
            }
          }
          setTimeout(() => {
            that.$refs.custom_credit_days.focus()
          }, 100)
        } else if (value == 'cash') {
          this.form.scheduled_at = this.moment(this.form.created_at).toDate()
        }
      },
      deep: true,
    },
    'form.created_at': {
      handler: function (after) {
        var days = null

        if (this.form.selectedCredit == 'custom') {
          days = parseInt(this.form.inputCustomCreditDay)
        } else if (this.form.selectedCredit.search('days.') >= 0) {
          let arr = this.form.selectedCredit.split('.')
          days = parseInt(arr[1])
        }

        if (days !== null) {
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        }
      },
      deep: true,
    },
    'form.scheduled_at': {
      handler: function (after, before) {
        if (this.isFocusOnInputScheduled) {
          if (this.form.selectedCredit.search('days.') >= 0 || this.form.selectedCredit == 'custom') {
            var a = this.moment(this.form.scheduled_at)
            var b = this.moment(this.form.created_at)
            var diff = Math.round(a.diff(b, 'days', true)) // diff days
            this.form.inputCustomCreditDay = diff
            this.form.selectedCredit = 'custom'
          }
        }
      },
      deep: true,
    },
    'form.inputCustomCreditDay': {
      handler: function (after) {
        var value = after.toString()
        let days = parseInt(value)
        if (days >= 0) {
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        } else {
          this.form.inputCustomCreditDay = 0
        }
      },
      deep: true,
    },
    'form.pickedCustomerId': {
      handler: function (after) {
        let customer_id = after
        let customerInfo = this.getCustomerById(customer_id)

        this.form.customer.address = null
        this.form.customer.tax_id = null
        this.form.customer.email = null
        this.form.customer.tel = null

        if (customerInfo) {
          this.form.customer.address = customerInfo.address
          this.form.customer.tax_id = customerInfo.tax_id
          this.form.customer.email = this.getPartnerContact(customerInfo.contacts).email
          this.form.customer.tel = this.getPartnerContact(customerInfo.contacts).tel
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    /**
     *  validation
     */
    if (!this.$route.query.so_id) {
      return this.$router.push({ name: 'SaleOrderAll' })
    }
    // get category
    let res = await this.$store.dispatch('getSale', {
      so_id: this.$route.query.so_id,
    })
    if (!res.success) {
      return this.$router.push({ name: 'SaleOrderAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'SaleOrderAll' })
    }
    /**
     *  validation success
     */
    // set date format
    this.formats.input = [this.dateformat]
    this.formats.dayPopover = this.dateformat
    // get customers
    await this.$store.dispatch('getCustomers')
    // get taxes
    await this.$store.dispatch('getTaxes')

    for (let i = 0; i < this.sale.orders.length; i++) {
      const order = this.sale.orders[i]
      await this.$store.dispatch('getProductWithMerge', {
        sku_id: order.sku_id,
      })
    }

    // set data
    this.setData()
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.sales.title'),
      current: {
        app_name: 'sales',
        app_id: 5,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 0, [{
      'name': this.$route.query.so_code,
      'router': {
        'name': 'SaleOrderEdit',
        'query': {
          so_id: this.$route.query.so_id,
          so_code: this.$route.query.so_code,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 0,
      submenuAtIdx: 2,
    })
  },
  mounted: function () {
    // set popup modal
    this.setModal('#confirmdeleteModal')
    this.setModal('#printModal')
    this.setModal('#sharelinkModal')
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearProducts', 'clearCustomers', 'clearSale'])
  },
}
</script>

<style scoped>
  .scheduled {
    position: relative;
  }
  .scheduled .overlay {
    display: none;
  }
  .scheduled.disabled .overlay {
    position: absolute;
    width: -webkit-calc(100% - 30px);
  	width:    -moz-calc(100% - 30px);
  	width:         calc(100% - 30px);
    height: 38px;
    top: 32px;
    left: 15px;
    z-index: 1;
    display: block;
  }
</style>

<style>
.scheduled.disabled .popover-container input {
  background: #e9ecef !important;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/sales/so/Edit.vue